module.exports = __webpack_public_path__ + "static/media/Reservation-08.433498dc.svg";